
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11599',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11599",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.446",
  "dashboard-client-types": "static-1.239",
  "data-fetching-client": "static-1.9492",
  "foundations-components": "static-1.7550",
  "foundations-components-legacy": "static-1.575",
  "foundations-theming": "static-1.4226",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7820",
  "hub-http-shared-msw-handlers": "static-1.9507",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11247",
  "I18n": "static-7.1574",
  "jasmine-runner": "static-1.6287",
  "marketplace-storefront-base": "static-1.11659",
  "quartz": "static-1.6753",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16465",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2677",
  "reporting-testing-lib": "static-1.8514",
  "settings-ui-lib": "static-1.12337",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6757",
  "ui-addon-i18n": "static-1.10955",
  "ui-addon-react-router-dom": "static-1.9361",
  "unified-auth": "static-1.232",
  "unified-auth-core-lib": "static-1.513",
  "usage-tracker": "static-1.7149",
  "usage-tracker-core": "static-1.6999",
  "customer-data-property-utils": "static-1.7892",
  "history": "static-4.47",
  "hub-http": "static-1.6035",
  "integrations-lib": "static-1.15458",
  "marketplace-ui-common": "static-1.18986",
  "property-management-iframe": "static-1.12398",
  "quartz-config": "static-1.531",
  "quartz-core": "static-1.5972",
  "quartz-routing": "static-1.183",
  "quick-fetch": "static-1.3749",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4449",
  "ts-schema": "static-1.3918",
  "ui-universal-auth": "static-1.8718",
  "UIComponents": "static-3.8194",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3243",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3030",
  "quartz-webpack": "static-1.2977",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3819",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4651",
  "foundations-theming-specialty": "static-1.1942",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9242",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5187",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1247",
  "ui-fonts": "static-1.509",
  "ui-images": "static-2.1096",
  "bend-plugin-foundations-theming": "static-1.2709",
  "foundations-theming-base": "static-1.3211",
  "stylex": "static-1.27",
  "HeadJS": "static-2.713",
  "hs-test-utils-bend-plugin": "static-1.2931",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4141",
  "ai-components-ui-library": "static-1.8380",
  "ai-rendering-library": "static-1.9343",
  "chirp-fetch": "static-1.1697",
  "connections-embed-lib": "static-1.655",
  "copilot-toolkit": "static-1.10568",
  "laboratory-lib": "static-3.6975",
  "marketplace-embed": "static-1.21512",
  "marketplace-ui-details": "static-1.8882",
  "marketplace-ui-reviews": "static-1.18942",
  "marketplace-ui-tracking": "static-1.13157",
  "sanitize-text": "static-1.7956",
  "ui-addon-video-player": "static-1.8511",
  "usage-tracker-multi": "static-1.5563",
  "usage-tracker-session-replay": "static-1.4835",
  "wootric-nps": "static-1.6799",
  "apollo-link-hub-http": "static-2.4464",
  "immer": "static-1.33",
  "immerable": "static-1.3970",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66581",
  "cssUtils": "static-1.736",
  "flux-actions": "static-1.310",
  "HubStyle": "static-2.11555",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10024",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10186",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7139",
  "icons": "static-2.623",
  "marketplace-ui-apps-core": "static-1.17519",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4336",
  "foundations-components-test-utils": "static-1.5033",
  "quartz-i18n": "static-1.428",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3546",
  "customer-data-objects": "static-1.7464",
  "property-translator": "static-1.5227",
  "frontend-preferences-client": "static-1.7739",
  "hs-promise-utils": "static-1.5408",
  "hubspot-apollo-client": "static-1.4696",
  "integrations-error-boundary-lib": "static-1.12873",
  "integrations-tracking-lib": "static-1.5403",
  "native-integrations-shared-strings": "static-1.7603",
  "reselect": "static-2.16",
  "sanitize": "static-1.4289",
  "superstore": "static-1.4585",
  "ui-shepherd-react": "static-3.9962",
  "ai-settings-ui-library": "static-1.7482",
  "hub-http-janus": "static-1.798",
  "hubspotter-http": "static-1.4492",
  "immutable-less": "static-1.4469",
  "marketplace-ui-client-types": "static-1.16393",
  "nav-meta": "static-1.28948",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10051",
  "ui-addon-upgrades": "static-9.17680",
  "inbound-db-properties-service-client": "static-1.3689",
  "property-management-common": "static-1.4685",
  "ui-addon-iframeable": "static-1.8860",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.428",
  "quartz-head": "static-1.418",
  "quartz-test": "static-1.428",
  "quartz-tracking": "static-1.132",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2956",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20383",
  "ContentUtils": "static-1.67661",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2302",
  "customer-data-filters-ui": "static-1.38952",
  "customer-data-objects-ui-components": "static-1.12824",
  "customer-data-reference-ui-components": "static-1.12961",
  "embedded-academy-lib": "static-1.13590",
  "ExportDialog": "static-6.10202",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40692",
  "reporting-snowflake": "static-1.55199",
  "reporting-ui-components": "static-2.63852",
  "reporting-visualizations": "static-1.58657",
  "ui-addon-teams": "static-1.21262",
  "magpie-lib": "static-1.5409",
  "magpie-types": "static-1.4869",
  "simple-logging-lib": "static-1.2865",
  "navigation-components": "static-1.17311",
  "ai-studio-lib": "static-1.11037",
  "developer-experience-shared-components": "static-1.10295",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7805",
  "ui-tool-access": "static-1.9960",
  "usage-based-billing-components-lib": "static-1.8042",
  "usage-tracker-anonymous": "static-1.5566",
  "usage-tracker-public": "static-1.6960",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3431",
  "persist-promise": "static-1.3523",
  "reference-resolvers": "static-1.7975",
  "ui-extensibility-client-types": "static-1.3759",
  "hubspot-apollo-cache": "static-1.155",
  "universal-page-editor-lib": "static-1.2814",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2222",
  "merchandise-lib": "static-1.259",
  "atom": "static-1.4884",
  "purchase-motions-components": "static-1.5500",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1366",
  "crm-component-utils": "static-1.38512",
  "crm-properties-common-lib": "static-1.5687",
  "framework-data-schema-resolvers": "static-1.6688",
  "reference-resolvers-lite": "static-1.7909",
  "navigation-messaging": "static-1.6638",
  "hubspotter-http-shared-msw-handlers": "static-1.9505",
  "cms-field-types": "static-1.4621",
  "content-icons-ui": "static-1.2158",
  "conversations-skeleton-state": "static-1.7062",
  "crm-message-bus": "static-1.42405",
  "customer-data-filters-ui-msw-helpers": "static-1.21387",
  "customer-data-ui-utilities": "static-1.9638",
  "FormUrlGenerator": "static-2.4544",
  "framework-builder-read-service-client": "static-1.3847",
  "framework-data-schema-quick-fetch": "static-1.6593",
  "multi-account-reference-resolvers": "static-1.788",
  "onboarding-tours": "static-1.16282",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13091",
  "academy-common-lib": "static-1.13050",
  "content-assistance-lib": "static-1.7469",
  "dashboard-lib": "static-1.80679",
  "file-manager-components": "static-1.22929",
  "getting-started-shared-tasks": "static-1.17923",
  "hubspot-prosemirror": "static-1.17642",
  "hubspot-prosemirror-plugins": "static-1.17634",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19493",
  "share-with-third-party-component-lib": "static-1.8507",
  "ui-addon-draggable": "static-3.4580",
  "ui-asset-management-lib": "static-1.10729",
  "ui-business-units-lib": "static-1.8844",
  "user-context": "static-1.4914",
  "growth-payments-core": "static-1.24764",
  "reporting-plugins": "static-1.10003",
  "reporting-reports": "static-1.66259",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.540",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28881",
  "react-codemirror": "static-1.10442",
  "apps-service-types": "static-1.3692",
  "oauth-service-types": "static-1.4059",
  "onboarding-scopes": "static-1.6278",
  "onboarding-tours-client": "static-1.4496",
  "platform-infra-nav-components": "static-1.7506",
  "subscription-experience-data-types": "static-1.14605",
  "crm-record-cards-service-types": "static-1.3460",
  "location-customization-utils-lib": "static-1.8602",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4328",
  "nav-client-types": "static-1.2172",
  "purchase-motions-api": "static-1.5503",
  "signup-constants": "static-1.18436",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3729",
  "card-properties-lib": "static-1.43561",
  "crm-actions": "static-1.6118",
  "crm-cards-data": "static-1.1238",
  "crm-cards-sdk": "static-1.42959",
  "customer-data-properties": "static-1.50838",
  "customer-data-properties-shared-msw-handlers": "static-1.8834",
  "customer-data-tracking": "static-1.6697",
  "conditional-properties-service-client": "static-1.3637",
  "crm-pipelines-api-client-types": "static-1.3978",
  "multi-currency-client-types": "static-1.3531",
  "external-options-client-types": "static-1.3998",
  "react-dnd-compat": "static-1.4435",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5173",
  "growth-onboarding-confetti": "static-1.2887",
  "growth-onboarding-next-action-utils": "static-1.1325",
  "onboarding-tours-utils": "static-1.348",
  "ui-shepherd-tracker": "static-1.7343",
  "academy-service-client": "static-1.3495",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27979",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8199",
  "video-components-external": "static-1.10608",
  "video-data-lib": "static-1.34266",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8383",
  "payment-link-components": "static-1.22975",
  "ui-addon-emoji-picker": "static-1.9703",
  "EmailSignatureEditor": "static-1.23938",
  "viral-links-lib": "static-1.6850",
  "data-token-picker": "static-1.16064",
  "FileManagerLib": "static-1.38569",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5059",
  "getting-started-shared-tasks-store": "static-1.17041",
  "campaign-roi-lib": "static-1.8313",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.205",
  "eligibility-engine-service-types": "static-1.3010",
  "crm_data": "static-4.91255",
  "crm-links": "static-1.6081",
  "customer-data-sidebar": "static-2.45455",
  "enrichment-properties-lib": "static-1.15081",
  "crm-fe-perf": "static-1.22721",
  "calling-global-api": "static-1.63717",
  "calling-internal-common": "static-1.31109",
  "calling-lifecycle-internal": "static-1.65099",
  "calling-lifecycle-messages": "static-1.57393",
  "commerce-products-lib": "static-1.8898",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.493",
  "inbounddb-objects-service-types": "static-1.4062",
  "meetings-icalendar-utils-lib": "static-1.448",
  "object-builder-ui-client": "static-1.48024",
  "pipeline-validation-client-types": "static-1.3800",
  "property-value-citations": "static-1.1452",
  "pulse": "static-1.328",
  "smart-property-lib": "static-1.5963",
  "tiered-pricing": "static-1.850",
  "ui-addon-form-validation": "static-1.10809",
  "growth-onboarding-next-action-components": "static-1.1353",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6398",
  "content-media-composition-data-lib": "static-1.11508",
  "content-media-compositions": "static-2.15515",
  "media-bridge-lib": "static-1.18587",
  "commerce-tours-lib": "static-1.5740",
  "growth-onboarding-reliability": "static-1.4901",
  "sales-checkout-service-client": "static-1.3483",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21329",
  "sales-email-signature-service-client": "static-1.3659",
  "audio-components": "static-1.5632",
  "FileManagerCore": "static-1.38428",
  "FileManagerImages": "static-1.36080",
  "video-components": "static-1.12611",
  "crm_universal": "static-1.21682",
  "customer-data-email": "static-1.17692",
  "calling-error-reporting": "static-1.31115",
  "card-payment-highlight-lib": "static-1.36538",
  "card-subscription-highlight-lib": "static-1.38895",
  "commerce-billing-lib": "static-1.18537",
  "commerce-contract-lib": "static-1.11244",
  "customer-data-content": "static-1.26896",
  "invoices-highlight-card-lib": "static-1.54073",
  "orders-highlight-card-lib": "static-1.20903",
  "products-highlight-card-lib": "static-1.17182",
  "project-storage": "static-1.4548",
  "quotes-highlight-card-lib": "static-1.71255",
  "breeze-intelligence-kit": "static-1.5341",
  "crm-source-interpretation-lib": "static-1.5145",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9590",
  "policy-lib": "static-1.6601",
  "shared-worker-versioning": "static-1.10853",
  "calling-usage-tracker": "static-1.6355",
  "voice-sms-access-library": "static-1.285",
  "commerce-permissions": "static-1.574",
  "products-iframe-lib": "static-1.7354",
  "products-ui-components-shared-msw-handlers": "static-1.9889",
  "directed-graph": "static-1.751",
  "event-emitter": "static-1.762",
  "react-tinymce": "static-1.54657",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9653",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53783",
  "tinymce-plugins": "static-1.56897",
  "tinymce-themes": "static-1.55753",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4347",
  "video-embed": "static-1.35100",
  "social-insights-client-types": "static-1.21391",
  "sequences-lib": "static-1.7704",
  "ui-gdpr-components": "static-1.10162",
  "commerce-shared-components-lib": "static-1.17958",
  "commerce-subscription-lib": "static-1.36472",
  "commerce-tools-ui-lib": "static-1.9829",
  "utility-belt": "static-1.2355",
  "payments-enrollment-embed-lib": "static-1.22072",
  "products-ui-components": "static-1.39417",
  "quotes-client-types": "static-1.37344",
  "quotes-ui-lib": "static-1.79975",
  "SalesContentIndexUI": "static-3.8925",
  "accounting-integrations-ui-components": "static-1.6745",
  "invoices-ui-lib": "static-1.54089",
  "commerce-products-api": "static-1.1977",
  "SafeStorage": "static-1.4219",
  "invoices-iframe-lib": "static-1.56147",
  "quotes-modal-lib": "static-1.101932",
  "calling-orchestration-schema": "static-1.35062",
  "sales-views-client-types": "static-1.4102",
  "hub-http-contrib": "static-1.2858",
  "interframe": "static-3.4604",
  "tinymce-data": "static-1.39868",
  "ui-addon-sales-email": "static-1.5028",
  "layout-dnd-components": "static-1.12058",
  "layout-dnd-utils": "static-1.11033",
  "ui-brand-identity-lib": "static-1.13950",
  "NamespacedHubStyle": "static-2.8910",
  "outpost": "static-1.4018",
  "sequences-client-types-lib": "static-1.7561",
  "customer-data-associations": "static-1.7153",
  "framework-data-table": "static-2.11445",
  "customer-data-rte": "static-1.32477",
  "cv-backend-services": "static-1.1504",
  "growth-onboarding-empty-states": "static-1.5384",
  "InboxConnectUtils": "static-4.14260",
  "payments-post-enroll-local-storage-lib": "static-1.4926",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7155",
  "commerce-tax-lib": "static-1.332",
  "property-description-translator": "static-1.3673",
  "FireAlarmUi": "static-1.4343",
  "sales-templates-service-types-lib": "static-1.4005",
  "commerce-analytics-service-client": "static-1.3471",
  "totals-ui-components": "static-1.23033",
  "ContentData": "static-1.67736",
  "layout-data-lib": "static-1.9358",
  "deal-intel-decorators": "static-1.1297",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27745",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3651",
  "advanced-menus-core": "static-1.14834",
  "advanced-menus-lib": "static-1.11807",
  "ui-memberships-settings-lib": "static-1.33465",
  "deal-intel-utils": "static-1.1301",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14833",
  "simple-menus-lib": "static-1.16350"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11599",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.446",
  "dashboard-client-types": "/dashboard-client-types/static-1.239",
  "data-fetching-client": "/data-fetching-client/static-1.9492",
  "foundations-components": "/foundations-components/static-1.7550",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.575",
  "foundations-theming": "/foundations-theming/static-1.4226",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7820",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9507",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11247",
  "I18n": "/I18n/static-7.1574",
  "jasmine-runner": "/jasmine-runner/static-1.6287",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11659",
  "quartz": "/quartz/static-1.6753",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16465",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2677",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8514",
  "settings-ui-lib": "/settings-ui-lib/static-1.12337",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6757",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10955",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9361",
  "unified-auth": "/unified-auth/static-1.232",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.513",
  "usage-tracker": "/usage-tracker/static-1.7149",
  "usage-tracker-core": "/usage-tracker-core/static-1.6999",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7892",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6035",
  "integrations-lib": "/integrations-lib/static-1.15458",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18986",
  "property-management-iframe": "/property-management-iframe/static-1.12398",
  "quartz-config": "/quartz-config/static-1.531",
  "quartz-core": "/quartz-core/static-1.5972",
  "quartz-routing": "/quartz-routing/static-1.183",
  "quick-fetch": "/quick-fetch/static-1.3749",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4449",
  "ts-schema": "/ts-schema/static-1.3918",
  "ui-universal-auth": "/ui-universal-auth/static-1.8718",
  "UIComponents": "/UIComponents/static-3.8194",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3243",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3030",
  "quartz-webpack": "/quartz-webpack/static-1.2977",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3819",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4651",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1942",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9242",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5187",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1247",
  "ui-fonts": "/ui-fonts/static-1.509",
  "ui-images": "/ui-images/static-2.1096",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2709",
  "foundations-theming-base": "/foundations-theming-base/static-1.3211",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.713",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2931",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4141",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8380",
  "ai-rendering-library": "/ai-rendering-library/static-1.9343",
  "chirp-fetch": "/chirp-fetch/static-1.1697",
  "connections-embed-lib": "/connections-embed-lib/static-1.655",
  "copilot-toolkit": "/copilot-toolkit/static-1.10568",
  "laboratory-lib": "/laboratory-lib/static-3.6975",
  "marketplace-embed": "/marketplace-embed/static-1.21512",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8882",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18942",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13157",
  "sanitize-text": "/sanitize-text/static-1.7956",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8511",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5563",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4835",
  "wootric-nps": "/wootric-nps/static-1.6799",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4464",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3970",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66581",
  "cssUtils": "/cssUtils/static-1.736",
  "flux-actions": "/flux-actions/static-1.310",
  "HubStyle": "/HubStyle/static-2.11555",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10024",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10186",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7139",
  "icons": "/icons/static-2.623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17519",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4336",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5033",
  "quartz-i18n": "/quartz-i18n/static-1.428",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3546",
  "customer-data-objects": "/customer-data-objects/static-1.7464",
  "property-translator": "/property-translator/static-1.5227",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7739",
  "hs-promise-utils": "/hs-promise-utils/static-1.5408",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4696",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12873",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5403",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7603",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4289",
  "superstore": "/superstore/static-1.4585",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9962",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7482",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "hubspotter-http": "/hubspotter-http/static-1.4492",
  "immutable-less": "/immutable-less/static-1.4469",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16393",
  "nav-meta": "/nav-meta/static-1.28948",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10051",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17680",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3689",
  "property-management-common": "/property-management-common/static-1.4685",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8860",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.428",
  "quartz-head": "/quartz-head/static-1.418",
  "quartz-test": "/quartz-test/static-1.428",
  "quartz-tracking": "/quartz-tracking/static-1.132",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20383",
  "ContentUtils": "/ContentUtils/static-1.67661",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2302",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38952",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12824",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12961",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13590",
  "ExportDialog": "/ExportDialog/static-6.10202",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40692",
  "reporting-snowflake": "/reporting-snowflake/static-1.55199",
  "reporting-ui-components": "/reporting-ui-components/static-2.63852",
  "reporting-visualizations": "/reporting-visualizations/static-1.58657",
  "ui-addon-teams": "/ui-addon-teams/static-1.21262",
  "magpie-lib": "/magpie-lib/static-1.5409",
  "magpie-types": "/magpie-types/static-1.4869",
  "simple-logging-lib": "/simple-logging-lib/static-1.2865",
  "navigation-components": "/navigation-components/static-1.17311",
  "ai-studio-lib": "/ai-studio-lib/static-1.11037",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10295",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7805",
  "ui-tool-access": "/ui-tool-access/static-1.9960",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8042",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5566",
  "usage-tracker-public": "/usage-tracker-public/static-1.6960",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3431",
  "persist-promise": "/persist-promise/static-1.3523",
  "reference-resolvers": "/reference-resolvers/static-1.7975",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3759",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.155",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2814",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2222",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "atom": "/atom/static-1.4884",
  "purchase-motions-components": "/purchase-motions-components/static-1.5500",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1366",
  "crm-component-utils": "/crm-component-utils/static-1.38512",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5687",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6688",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7909",
  "navigation-messaging": "/navigation-messaging/static-1.6638",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9505",
  "cms-field-types": "/cms-field-types/static-1.4621",
  "content-icons-ui": "/content-icons-ui/static-1.2158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7062",
  "crm-message-bus": "/crm-message-bus/static-1.42405",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21387",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9638",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4544",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3847",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6593",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.788",
  "onboarding-tours": "/onboarding-tours/static-1.16282",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13091",
  "academy-common-lib": "/academy-common-lib/static-1.13050",
  "content-assistance-lib": "/content-assistance-lib/static-1.7469",
  "dashboard-lib": "/dashboard-lib/static-1.80679",
  "file-manager-components": "/file-manager-components/static-1.22929",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17923",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17642",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17634",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19493",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8507",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4580",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10729",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8844",
  "user-context": "/user-context/static-1.4914",
  "growth-payments-core": "/growth-payments-core/static-1.24764",
  "reporting-plugins": "/reporting-plugins/static-1.10003",
  "reporting-reports": "/reporting-reports/static-1.66259",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.540",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28881",
  "react-codemirror": "/react-codemirror/static-1.10442",
  "apps-service-types": "/apps-service-types/static-1.3692",
  "oauth-service-types": "/oauth-service-types/static-1.4059",
  "onboarding-scopes": "/onboarding-scopes/static-1.6278",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4496",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7506",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14605",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8602",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4328",
  "nav-client-types": "/nav-client-types/static-1.2172",
  "purchase-motions-api": "/purchase-motions-api/static-1.5503",
  "signup-constants": "/signup-constants/static-1.18436",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3729",
  "card-properties-lib": "/card-properties-lib/static-1.43561",
  "crm-actions": "/crm-actions/static-1.6118",
  "crm-cards-data": "/crm-cards-data/static-1.1238",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42959",
  "customer-data-properties": "/customer-data-properties/static-1.50838",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8834",
  "customer-data-tracking": "/customer-data-tracking/static-1.6697",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3637",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3978",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3531",
  "external-options-client-types": "/external-options-client-types/static-1.3998",
  "react-dnd-compat": "/react-dnd-compat/static-1.4435",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5173",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2887",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1325",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.348",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7343",
  "academy-service-client": "/academy-service-client/static-1.3495",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27979",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8199",
  "video-components-external": "/video-components-external/static-1.10608",
  "video-data-lib": "/video-data-lib/static-1.34266",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8383",
  "payment-link-components": "/payment-link-components/static-1.22975",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9703",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23938",
  "viral-links-lib": "/viral-links-lib/static-1.6850",
  "data-token-picker": "/data-token-picker/static-1.16064",
  "FileManagerLib": "/FileManagerLib/static-1.38569",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5059",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17041",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8313",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.205",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3010",
  "crm_data": "/crm_data/static-4.91255",
  "crm-links": "/crm-links/static-1.6081",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45455",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15081",
  "crm-fe-perf": "/crm-fe-perf/static-1.22721",
  "calling-global-api": "/calling-global-api/static-1.63717",
  "calling-internal-common": "/calling-internal-common/static-1.31109",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65099",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57393",
  "commerce-products-lib": "/commerce-products-lib/static-1.8898",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.493",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4062",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.448",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48024",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3800",
  "property-value-citations": "/property-value-citations/static-1.1452",
  "pulse": "/pulse/static-1.328",
  "smart-property-lib": "/smart-property-lib/static-1.5963",
  "tiered-pricing": "/tiered-pricing/static-1.850",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10809",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1353",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6398",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11508",
  "content-media-compositions": "/content-media-compositions/static-2.15515",
  "media-bridge-lib": "/media-bridge-lib/static-1.18587",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5740",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4901",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3483",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21329",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3659",
  "audio-components": "/audio-components/static-1.5632",
  "FileManagerCore": "/FileManagerCore/static-1.38428",
  "FileManagerImages": "/FileManagerImages/static-1.36080",
  "video-components": "/video-components/static-1.12611",
  "crm_universal": "/crm_universal/static-1.21682",
  "customer-data-email": "/customer-data-email/static-1.17692",
  "calling-error-reporting": "/calling-error-reporting/static-1.31115",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36538",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38895",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18537",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11244",
  "customer-data-content": "/customer-data-content/static-1.26896",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54073",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20903",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17182",
  "project-storage": "/project-storage/static-1.4548",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71255",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5341",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5145",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9590",
  "policy-lib": "/policy-lib/static-1.6601",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10853",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6355",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.285",
  "commerce-permissions": "/commerce-permissions/static-1.574",
  "products-iframe-lib": "/products-iframe-lib/static-1.7354",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9889",
  "directed-graph": "/directed-graph/static-1.751",
  "event-emitter": "/event-emitter/static-1.762",
  "react-tinymce": "/react-tinymce/static-1.54657",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9653",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53783",
  "tinymce-plugins": "/tinymce-plugins/static-1.56897",
  "tinymce-themes": "/tinymce-themes/static-1.55753",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4347",
  "video-embed": "/video-embed/static-1.35100",
  "social-insights-client-types": "/social-insights-client-types/static-1.21391",
  "sequences-lib": "/sequences-lib/static-1.7704",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10162",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17958",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36472",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9829",
  "utility-belt": "/utility-belt/static-1.2355",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22072",
  "products-ui-components": "/products-ui-components/static-1.39417",
  "quotes-client-types": "/quotes-client-types/static-1.37344",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79975",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8925",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6745",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54089",
  "commerce-products-api": "/commerce-products-api/static-1.1977",
  "SafeStorage": "/SafeStorage/static-1.4219",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56147",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101932",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35062",
  "sales-views-client-types": "/sales-views-client-types/static-1.4102",
  "hub-http-contrib": "/hub-http-contrib/static-1.2858",
  "interframe": "/interframe/static-3.4604",
  "tinymce-data": "/tinymce-data/static-1.39868",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5028",
  "layout-dnd-components": "/layout-dnd-components/static-1.12058",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11033",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13950",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8910",
  "outpost": "/outpost/static-1.4018",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7561",
  "customer-data-associations": "/customer-data-associations/static-1.7153",
  "framework-data-table": "/framework-data-table/static-2.11445",
  "customer-data-rte": "/customer-data-rte/static-1.32477",
  "cv-backend-services": "/cv-backend-services/static-1.1504",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5384",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14260",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4926",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7155",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.332",
  "property-description-translator": "/property-description-translator/static-1.3673",
  "FireAlarmUi": "/FireAlarmUi/static-1.4343",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4005",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3471",
  "totals-ui-components": "/totals-ui-components/static-1.23033",
  "ContentData": "/ContentData/static-1.67736",
  "layout-data-lib": "/layout-data-lib/static-1.9358",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1297",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27745",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3651",
  "advanced-menus-core": "/advanced-menus-core/static-1.14834",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11807",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33465",
  "deal-intel-utils": "/deal-intel-utils/static-1.1301",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14833",
  "simple-menus-lib": "/simple-menus-lib/static-1.16350"
}
};
